module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isShowHeader) ? _c('header', {
    staticClass: "header vux-1px-b",
    style: ([_vm.headerStyle, {
      minHeight: _vm.heigit + 'px'
    }])
  }, [_c('div', {
    staticClass: "back-btn action-btn",
    style: (_vm.leftBtnStyle),
    attrs: {
      "slot": "leftBtn"
    },
    on: {
      "click": _vm.onLeftAction
    },
    slot: "leftBtn"
  }, [_vm._t("leftBtn", [_c('i', {
    staticClass: "icon iconfont"
  }, [_vm._v("")])])], 2), _vm._v(" "), _c('div', {
    staticClass: "nav-title"
  }, [_vm._v(_vm._s(_vm.navTitle))]), _vm._v(" "), _c('div', {
    staticClass: "right-btn action-btn",
    style: (_vm.rightBtnStyle),
    on: {
      "click": _vm.onRightAction
    }
  }, [_vm._t("rightBtn")], 2)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-553781be"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header/index.vue
// module id = 54
// module chunks = 7 8 10 13 16 17 20 21 25